import React from 'react'

import axios from 'axios'
import { baseUrl } from '../../config/clientsConfig'

const EstimateService =  {
  
    getUnits : async (id) => {
        return axios.get(`${baseUrl}/units/getUnitsNo?docId=${id}`)
    },
    getPropertyUnits : async (id, towerId = null) =>{
        if(towerId)
        {
            return axios.get(`${baseUrl}/units/getUnitName?docId=${id}&towerId=${towerId}`)
        }else{
            return axios.get(`${baseUrl}/units/getUnitName?docId=${id}`)
        }
      
    },
    getTowerProperty : async (id) =>{
        return axios.get(`${baseUrl}/property/getTowerName/${id}`)
    },
    getPropertyPopulatedData : async (body) =>{
        return axios.post(`${baseUrl}/plotEstimate/getPropertyPrePopulatedData` , body)
    },
    estimateCreating : async (body , config) =>{
        return axios.post(`${baseUrl}/propertyEstimate` , body , config)
    },
    getEstimateList : async (body) =>{
        return axios.post(`${baseUrl}/plotEstimates` , body)
    },
    getEstimateLead : async (body) =>{
        return axios.post(`${baseUrl}/leads/getLeadsNameAndPhoneNumberForEstimate` , body)
    }
}

export default EstimateService